import { gql, useQuery } from '@apollo/client';

export const GET_STRIPE_ACCOUNT_ADDRESS = gql`
  query getStripeAccountAddress {
    getStripeAccountAddress {
      company
      street
      zipCode
      city
      country
    }
  }
`;

export const useGetStripeAccountAddress = () => {
  const { data, loading } = useQuery(GET_STRIPE_ACCOUNT_ADDRESS);

  return {
    stripeAddress: data?.getStripeAccountAddress || {},
    loading,
  };
};
